import * as constants from './constants';

export const ALL = 0;

export const select = (id, optionId, orderId, qty) => ({type: constants.SELECT_SELLITEMS, payload: {id, optionId, orderId, qty}});
export const all = () => ({type: constants.SELECT_SELLITEMS, payload: ALL});
export const reset = () => ({type: constants.RESET_SELLITEMS});
